import { Box } from "@chakra-ui/react"
import Home from "../../Components/Homepage/Home"


const Homepage = () => {
  return (
    <Box >
       <Home/>
    </Box>
  )
}

export default Homepage